var map = {
	"./App": 88075,
	"./App.vue": 88075,
	"./assets/AminoAcid/banner1.png": 26568,
	"./assets/AminoAcid/banner_title.png": 93318,
	"./assets/AminoAcid/module2_bg.png": 32203,
	"./assets/AminoAcid/module2_ele1.png": 85427,
	"./assets/AminoAcid/module2_ele2.png": 10936,
	"./assets/AminoAcid/module2_ele3.png": 79201,
	"./assets/AminoAcid/module2_ele4.png": 43086,
	"./assets/AminoAcid/module2_ele5.png": 86103,
	"./assets/AminoAcid/module3_bg.jpeg": 15701,
	"./assets/Application/electric.png": 61927,
	"./assets/Application/farm.png": 42042,
	"./assets/Application/package.png": 10660,
	"./assets/Application/pig.png": 83624,
	"./assets/Application/toy.png": 27080,
	"./assets/BioIntelligent/Industry.png": 85921,
	"./assets/BioIntelligent/Laboratory.png": 75960,
	"./assets/BioIntelligent/aminoacidsynthesis.jfif": 78364,
	"./assets/BioIntelligent/banner_img.png": 96117,
	"./assets/BioIntelligent/banner_title.png": 17066,
	"./assets/BioIntelligent/component_1.png": 90770,
	"./assets/BioIntelligent/component_2.png": 5385,
	"./assets/BioIntelligent/component_3.png": 27264,
	"./assets/BioIntelligent/component_title.png": 53529,
	"./assets/BioIntelligent/customsolution.png": 86839,
	"./assets/BioIntelligent/flow.png": 14219,
	"./assets/BioIntelligent/hangzhou.jfif": 5881,
	"./assets/BioIntelligent/jiande.jfif": 45010,
	"./assets/BioIntelligent/module1_bg.jpeg": 97543,
	"./assets/BioIntelligent/nanyang.jfif": 1420,
	"./assets/BioIntelligent/newmaterial.png": 42234,
	"./assets/BioIntelligent/part4.png": 77762,
	"./assets/BioIntelligent/productsolution.jfif": 72843,
	"./assets/BioIntelligent/swipper1.png": 75904,
	"./assets/BioIntelligent/swipper2.png": 54235,
	"./assets/BioIntelligent/swipper3.png": 39410,
	"./assets/CorporateVision/corp1.png": 18106,
	"./assets/CorporateVision/corp2.png": 39217,
	"./assets/CorporateVision/corp3.png": 29000,
	"./assets/CorporateVision/corp4.png": 8615,
	"./assets/CorporateVision/corp5.png": 56126,
	"./assets/CorporateVision/corp6.png": 58229,
	"./assets/CorporateVision/corp7.png": 5964,
	"./assets/CorporateVision/corp8.png": 85851,
	"./assets/KnotWeed/banner1.jpeg": 75817,
	"./assets/NewMaterial/P001-1.png": 17904,
	"./assets/NewMaterial/P001-2.jpeg": 80236,
	"./assets/NewMaterial/P001-3.jpeg": 95539,
	"./assets/NewMaterial/P002-1.jpeg": 70228,
	"./assets/NewMaterial/P002-2.jpeg": 55733,
	"./assets/NewMaterial/P002-3.jpeg": 95470,
	"./assets/NewMaterial/P003-1.jpeg": 12039,
	"./assets/NewMaterial/P003-2.png": 72421,
	"./assets/NewMaterial/P003-3.png": 43004,
	"./assets/NewMaterial/P003-4.png": 42963,
	"./assets/NewMaterial/P003-5.png": 87754,
	"./assets/NewMaterial/P003-6.png": 36737,
	"./assets/NewMaterial/P004-1.jpeg": 97094,
	"./assets/NewMaterial/P004-2.png": 84002,
	"./assets/NewMaterial/P004-3.png": 74507,
	"./assets/NewMaterial/P004-4.jpg": 10320,
	"./assets/NewMaterial/P005-1.jpg": 21624,
	"./assets/NewMaterial/P005-2.png": 96535,
	"./assets/News/202505/news10_pic_1.png": 38235,
	"./assets/News/202505/news10_pic_2.png": 83200,
	"./assets/News/202505/news10_pic_3.png": 54377,
	"./assets/News/202505/news10_pic_4.png": 80118,
	"./assets/News/202505/news10_pic_5.png": 58207,
	"./assets/News/202505/news10_pic_6.png": 28292,
	"./assets/News/202505/news10_pic_7.png": 70797,
	"./assets/News/202505/news10_pic_8.png": 66938,
	"./assets/News/202505/news10_pic_9.png": 88515,
	"./assets/News/202505/news11_pic_1.png": 46166,
	"./assets/News/202505/news11_pic_10.jpg": 26304,
	"./assets/News/202505/news11_pic_11.jpg": 94397,
	"./assets/News/202505/news11_pic_2.jpg": 61021,
	"./assets/News/202505/news11_pic_3.jpg": 9888,
	"./assets/News/202505/news11_pic_4.jpg": 76371,
	"./assets/News/202505/news11_pic_5.jpg": 89910,
	"./assets/News/202505/news11_pic_6.jpg": 76609,
	"./assets/News/202505/news11_pic_7.png": 49248,
	"./assets/News/202505/news11_pic_8.jpg": 56631,
	"./assets/News/202505/news11_pic_9.jpg": 9146,
	"./assets/News/202505/news11_video1_poster.jpg": 83672,
	"./assets/News/202505/news11_video2_poster.jpg": 14525,
	"./assets/News/202505/news12_pic_1.jpg": 29469,
	"./assets/News/202505/news12_pic_10.jpg": 51473,
	"./assets/News/202505/news12_pic_11.jpg": 54100,
	"./assets/News/202505/news12_pic_2.png": 14614,
	"./assets/News/202505/news12_pic_3.jpg": 91951,
	"./assets/News/202505/news12_pic_4.jpg": 67012,
	"./assets/News/202505/news12_pic_5.jpg": 45057,
	"./assets/News/202505/news12_pic_6.jpg": 74710,
	"./assets/News/202505/news12_pic_7.jpg": 61171,
	"./assets/News/202505/news12_pic_8.jpg": 73032,
	"./assets/News/202505/news12_pic_9.jpg": 197,
	"./assets/News/202505/news13_pic_1.png": 89432,
	"./assets/News/202505/news13_pic_2.png": 63923,
	"./assets/News/202505/news13_pic_3.png": 13162,
	"./assets/News/202505/news14_head_1.png": 88677,
	"./assets/News/202505/news14_pic_1.jpg": 49247,
	"./assets/News/202505/news14_pic_2.jpg": 34896,
	"./assets/News/202505/news14_pic_3.jpg": 3469,
	"./assets/News/202505/news15_head_1.jpg": 94350,
	"./assets/News/202505/news15_head_2.jpg": 93017,
	"./assets/News/202505/news15_head_3.jpg": 48668,
	"./assets/News/202505/news15_pic_1.jpg": 29086,
	"./assets/News/202505/news15_pic_2.png": 53905,
	"./assets/News/202505/news16_head_1.jpg": 71191,
	"./assets/News/202505/news16_head_2.jpg": 60264,
	"./assets/News/202505/news16_head_3.jpg": 87877,
	"./assets/News/202505/news16_head_4.jpg": 40542,
	"./assets/News/202505/news16_pic_1.jpg": 64553,
	"./assets/News/202505/news16_pic_2.png": 84058,
	"./assets/News/202505/news16_pic_3.jpg": 69307,
	"./assets/News/202505/news17_pic_1.jpg": 98840,
	"./assets/News/202505/news17_pic_2.jpg": 78823,
	"./assets/News/202505/news17_pic_3.jpg": 11082,
	"./assets/News/202505/news17_pic_4.jpg": 47801,
	"./assets/News/202505/news17_pic_5.jpg": 60924,
	"./assets/News/202505/news17_pic_6.jpg": 45579,
	"./assets/News/202505/news17_pic_7.jpg": 67534,
	"./assets/News/202505/news18_head_1.jpg": 36185,
	"./assets/News/202505/news1_footer_1.png": 78260,
	"./assets/News/202505/news1_head_1.jpg": 27907,
	"./assets/News/202505/news1_video1_pic.jpg": 81326,
	"./assets/News/202505/news2_pic_0.jpg": 45375,
	"./assets/News/202505/news2_pic_1.png": 99462,
	"./assets/News/202505/news2_pic_10.jpg": 40944,
	"./assets/News/202505/news2_pic_11.png": 76349,
	"./assets/News/202505/news2_pic_12.png": 95142,
	"./assets/News/202505/news2_pic_13.jpg": 38943,
	"./assets/News/202505/news2_pic_14.jpg": 87508,
	"./assets/News/202505/news2_pic_15.png": 97561,
	"./assets/News/202505/news2_pic_16.jpg": 74086,
	"./assets/News/202505/news2_pic_2.jpg": 57517,
	"./assets/News/202505/news2_pic_3.jpg": 30416,
	"./assets/News/202505/news2_pic_4.jpg": 45219,
	"./assets/News/202505/news2_pic_5.jpg": 64166,
	"./assets/News/202505/news2_pic_6.jpg": 21937,
	"./assets/News/202505/news2_pic_7.jpg": 43412,
	"./assets/News/202505/news2_pic_8.png": 46167,
	"./assets/News/202505/news2_pic_9.jpg": 2410,
	"./assets/News/202505/news3_video1_poster.png": 19317,
	"./assets/News/202505/news4_head_2.png": 71223,
	"./assets/News/202505/news4_head_3.jpg": 94282,
	"./assets/News/202505/news4_pic_1.jpg": 9032,
	"./assets/News/202505/news4_pic_10.jpg": 17970,
	"./assets/News/202505/news4_pic_11.jpg": 77999,
	"./assets/News/202505/news4_pic_2.jpg": 93783,
	"./assets/News/202505/news4_pic_3.jpg": 29946,
	"./assets/News/202505/news4_pic_4.jpg": 50633,
	"./assets/News/202505/news4_pic_5.jpg": 12588,
	"./assets/News/202505/news4_pic_6.jpg": 39035,
	"./assets/News/202505/news4_pic_7.jpg": 7550,
	"./assets/News/202505/news4_pic_8.jpg": 81821,
	"./assets/News/202505/news4_pic_9.jpg": 30688,
	"./assets/News/202505/news5_pic_01.png": 38131,
	"./assets/News/202505/news5_pic_1.jpg": 80377,
	"./assets/News/202505/news5_pic_2.png": 29482,
	"./assets/News/202505/news5_pic_3.png": 80243,
	"./assets/News/202505/news5_pic_4.png": 80284,
	"./assets/News/202505/news6_pic_1.jpg": 73422,
	"./assets/News/202505/news6_pic_2.jpg": 80537,
	"./assets/News/202505/news6_pic_3.jpg": 59484,
	"./assets/News/202505/news6_pic_4.jpg": 65479,
	"./assets/News/202505/news6_pic_5.jpg": 9642,
	"./assets/News/202505/news6_pic_6.jpg": 35893,
	"./assets/News/202505/news6_pic_7.jpg": 11672,
	"./assets/News/202505/news7_pic_1.png": 34719,
	"./assets/News/202505/news7_pic_2.jpg": 13408,
	"./assets/News/202505/news7_pic_3.jpg": 52637,
	"./assets/News/202505/news8_pic_1.jpg": 75492,
	"./assets/News/202505/news8_pic_10.png": 29090,
	"./assets/News/202505/news8_pic_11.png": 50219,
	"./assets/News/202505/news8_pic_12.jpg": 51828,
	"./assets/News/202505/news8_pic_2.jpg": 69651,
	"./assets/News/202505/news8_pic_3.png": 48562,
	"./assets/News/202505/news8_pic_4.png": 30125,
	"./assets/News/202505/news8_pic_5.png": 87620,
	"./assets/News/202505/news8_pic_6.jpg": 431,
	"./assets/News/202505/news8_pic_7.jpg": 28050,
	"./assets/News/202505/news8_pic_8.jpg": 6761,
	"./assets/News/202505/news8_pic_9.jpg": 68716,
	"./assets/News/202505/news9_pic_1.png": 25525,
	"./assets/News/202505/news9_pic_2.jpg": 27386,
	"./assets/News/202505/news_1.png": 86997,
	"./assets/News/202505/news_10.png": 21873,
	"./assets/News/202505/news_11.jpg": 82860,
	"./assets/News/202505/news_12.jpg": 25659,
	"./assets/News/202505/news_13.png": 17114,
	"./assets/News/202505/news_15.png": 88620,
	"./assets/News/202505/news_16.jpg": 37207,
	"./assets/News/202505/news_17.jpg": 42746,
	"./assets/News/202505/news_18.jpg": 17537,
	"./assets/News/202505/news_2.png": 84894,
	"./assets/News/202505/news_3.jpg": 36343,
	"./assets/News/202505/news_4.png": 81064,
	"./assets/News/202505/news_5.jpg": 93193,
	"./assets/News/202505/news_6.jpg": 66462,
	"./assets/News/202505/news_7.jpg": 97947,
	"./assets/News/202505/news_8.png": 74052,
	"./assets/News/202505/news_9.png": 16557,
	"./assets/News/202505/news_pic_5.jpg": 72764,
	"./assets/News/202508/news34_pic_1.jpg": 14566,
	"./assets/News/202508/news34_pic_10.jpg": 15452,
	"./assets/News/202508/news34_pic_11.jpg": 36505,
	"./assets/News/202508/news34_pic_12.jpg": 29390,
	"./assets/News/202508/news34_pic_13.jpg": 7435,
	"./assets/News/202508/news34_pic_14.jpg": 67640,
	"./assets/News/202508/news34_pic_16.jpg": 65610,
	"./assets/News/202508/news34_pic_17.jpg": 21447,
	"./assets/News/202508/news34_pic_18.jpg": 22388,
	"./assets/News/202508/news34_pic_19.jpg": 36721,
	"./assets/News/202508/news34_pic_2.jpg": 55985,
	"./assets/News/202508/news34_pic_20.jpg": 25133,
	"./assets/News/202508/news34_pic_21.jpg": 81680,
	"./assets/News/202508/news34_pic_22.jpg": 12991,
	"./assets/News/202508/news34_pic_23.jpg": 76642,
	"./assets/News/202508/news34_pic_24.jpg": 89553,
	"./assets/News/202508/news34_pic_25.jpg": 11028,
	"./assets/News/202508/news34_pic_26.jpg": 12835,
	"./assets/News/202508/news34_pic_27.jpg": 31782,
	"./assets/News/202508/news34_pic_28.jpg": 21013,
	"./assets/News/202508/news34_pic_29.jpg": 30104,
	"./assets/News/202508/news34_pic_3.jpg": 58612,
	"./assets/News/202508/news34_pic_30.jpg": 26134,
	"./assets/News/202508/news34_pic_31.jpg": 12595,
	"./assets/News/202508/news34_pic_32.jpg": 18436,
	"./assets/News/202508/news34_pic_33.jpg": 96481,
	"./assets/News/202508/news34_pic_34.jpg": 70994,
	"./assets/News/202508/news34_pic_35.jpg": 43375,
	"./assets/News/202508/news34_pic_36.jpg": 29760,
	"./assets/News/202508/news34_pic_37.jpg": 80893,
	"./assets/News/202508/news34_pic_38.jpg": 6622,
	"./assets/News/202508/news34_pic_39.jpg": 38107,
	"./assets/News/202508/news34_pic_4.jpg": 79423,
	"./assets/News/202508/news34_pic_40.jpg": 53039,
	"./assets/News/202508/news34_pic_41.jpg": 80658,
	"./assets/News/202508/news34_pic_42.jpg": 90557,
	"./assets/News/202508/news34_pic_43.jpg": 39424,
	"./assets/News/202508/news34_pic_44.jpg": 22259,
	"./assets/News/202508/news34_pic_45.jpg": 35798,
	"./assets/News/202508/news34_pic_46.jpg": 6145,
	"./assets/News/202508/news34_pic_47.jpg": 28100,
	"./assets/News/202508/news34_pic_48.jpg": 2519,
	"./assets/News/202508/news34_pic_49.jpg": 38682,
	"./assets/News/202508/news34_pic_5.jpg": 66754,
	"./assets/News/202508/news34_pic_50.jpg": 89264,
	"./assets/News/202508/news34_pic_6.jpg": 96013,
	"./assets/News/202508/news34_pic_7.jpg": 95088,
	"./assets/News/202508/news34_pic_8.jpg": 76843,
	"./assets/News/202508/news34_pic_9.jpg": 97358,
	"./assets/News/202508/news34_tail_1.png": 78370,
	"./assets/News/202508/news34_tail_2.png": 18105,
	"./assets/News/202508/news34_title_1.png": 89668,
	"./assets/News/202508/news34_title_2.png": 3231,
	"./assets/News/202508/news35_pic_1.jpg": 69287,
	"./assets/News/202508/news35_pic_1.png": 47863,
	"./assets/News/202508/news35_pic_2.jpg": 89304,
	"./assets/News/202508/news35_pic_3.jpg": 93621,
	"./assets/News/202508/news35_pic_4.jpg": 57998,
	"./assets/News/202508/news35_pic_5.jpg": 36043,
	"./assets/News/202508/news35_pic_6.jpg": 67740,
	"./assets/News/202508/news35_title_1.jpg": 17561,
	"./assets/News/202508/news35_title_2.jpg": 26798,
	"./assets/News/202508/news36_head_1.jpg": 87424,
	"./assets/News/202508/news36_pic_1.jpg": 32608,
	"./assets/News/202508/news36_pic_2.jpg": 99247,
	"./assets/News/202508/news37_head_1.png": 55615,
	"./assets/News/202508/news37_pic_1.jpg": 31409,
	"./assets/News/202508/news37_pic_2.jpg": 73638,
	"./assets/News/202508/news37_pic_3.jpg": 12163,
	"./assets/News/202508/news37_title_1.jpg": 20295,
	"./assets/News/202508/news37_title_2.jpg": 87448,
	"./assets/News/268.png": 8279,
	"./assets/News/640.png": 32957,
	"./assets/News/Grid.png": 26607,
	"./assets/News/mint.png": 84007,
	"./assets/News/new10_head_3.jpg": 20619,
	"./assets/News/new11_head_2.jpg": 28093,
	"./assets/News/new11_head_3.jpg": 72512,
	"./assets/News/new12_head_1.jpg": 43099,
	"./assets/News/new1_head_3.jpg": 51721,
	"./assets/News/new2_head_3.jpg": 47840,
	"./assets/News/new3_head_3.jpg": 29835,
	"./assets/News/new4_head_3.jpg": 10754,
	"./assets/News/new6_head_3.jpg": 46372,
	"./assets/News/new8_head_2.jpg": 99283,
	"./assets/News/new8_head_3.jpg": 36118,
	"./assets/News/new9_head_3.jpg": 85345,
	"./assets/News/new_footer_1.jpg": 20819,
	"./assets/News/new_footer_2.jpg": 78244,
	"./assets/News/new_head_1.jpg": 93008,
	"./assets/News/new_head_2.jpg": 7967,
	"./assets/News/news08.png": 10346,
	"./assets/News/news_01.jpg": 25818,
	"./assets/News/news_02.jpg": 48421,
	"./assets/News/news_03.jpg": 86056,
	"./assets/News/news_04.jpg": 8731,
	"./assets/News/news_05.jpg": 53950,
	"./assets/News/news_06.jpg": 27657,
	"./assets/News/news_07.jpeg": 96501,
	"./assets/News/news_09.jpg": 48946,
	"./assets/News/news_10.jpg": 84568,
	"./assets/News/news_10_1.png": 61804,
	"./assets/News/news_11.jpg": 92437,
	"./assets/News/news_11_1.png": 2877,
	"./assets/News/news_11_10.png": 49225,
	"./assets/News/news_11_11.png": 94400,
	"./assets/News/news_11_12.png": 33083,
	"./assets/News/news_11_2.png": 21670,
	"./assets/News/news_11_3.png": 60687,
	"./assets/News/news_11_4.png": 48464,
	"./assets/News/news_11_5.png": 54713,
	"./assets/News/news_11_6.png": 98626,
	"./assets/News/news_11_7.png": 36107,
	"./assets/News/news_11_8.png": 10268,
	"./assets/News/news_11_9.png": 93157,
	"./assets/News/news_12.jpg": 66186,
	"./assets/News/news_12_1.png": 15914,
	"./assets/News/news_12_10.png": 57616,
	"./assets/News/news_12_11.png": 89721,
	"./assets/News/news_12_12.png": 75714,
	"./assets/News/news_12_2.png": 64897,
	"./assets/News/news_12_3.png": 96632,
	"./assets/News/news_12_4.png": 71799,
	"./assets/News/news_12_5.png": 28782,
	"./assets/News/news_12_6.png": 581,
	"./assets/News/news_12_7.png": 87516,
	"./assets/News/news_12_8.png": 91115,
	"./assets/News/news_12_9.png": 69986,
	"./assets/News/news_13.jpg": 38375,
	"./assets/News/news_13_1.png": 92795,
	"./assets/News/news_13_10.png": 61715,
	"./assets/News/news_13_11.png": 6506,
	"./assets/News/news_13_12.png": 55489,
	"./assets/News/news_13_13.png": 70872,
	"./assets/News/news_13_2.png": 95232,
	"./assets/News/news_13_3.png": 19433,
	"./assets/News/news_13_4.png": 69462,
	"./assets/News/news_13_5.png": 23263,
	"./assets/News/news_13_6.png": 37988,
	"./assets/News/news_13_7.png": 1229,
	"./assets/News/news_13_8.png": 48346,
	"./assets/News/news_13_9.png": 38179,
	"./assets/News/news_14.jpg": 16028,
	"./assets/News/news_14_1.png": 29536,
	"./assets/News/news_14_2.png": 91515,
	"./assets/News/news_14_3.png": 76690,
	"./assets/News/news_14_4.png": 81549,
	"./assets/News/news_14_5.png": 27652,
	"./assets/News/news_14_6.png": 80863,
	"./assets/News/news_15.jpg": 37081,
	"./assets/News/news_15_1.png": 61361,
	"./assets/News/news_15_2.png": 1466,
	"./assets/News/news_15_3.png": 91299,
	"./assets/News/news_15_4.png": 41900,
	"./assets/News/news_15_5.png": 53525,
	"./assets/News/news_15_6.png": 33150,
	"./assets/News/news_15_7.png": 8935,
	"./assets/News/news_3_1.png": 65724,
	"./assets/News/news_3_2.png": 50007,
	"./assets/News/news_3_3.png": 6990,
	"./assets/News/news_4_1.png": 22543,
	"./assets/News/news_4_2.png": 48052,
	"./assets/News/news_4_3.png": 81085,
	"./assets/News/news_4_4.png": 76834,
	"./assets/News/news_4_5.png": 97963,
	"./assets/News/news_4_6.png": 26672,
	"./assets/News/news_6_1.png": 30433,
	"./assets/News/news_6_10.png": 76565,
	"./assets/News/news_6_11.png": 24300,
	"./assets/News/news_6_12.png": 43303,
	"./assets/News/news_6_13.png": 74462,
	"./assets/News/news_6_2.png": 81450,
	"./assets/News/news_6_3.png": 36659,
	"./assets/News/news_6_4.png": 36700,
	"./assets/News/news_6_5.png": 66117,
	"./assets/News/news_6_6.png": 94318,
	"./assets/News/news_6_7.png": 37335,
	"./assets/News/news_6_8.png": 86800,
	"./assets/News/news_6_9.png": 83705,
	"./assets/News/news_7_1.png": 26544,
	"./assets/News/news_7_2png.jpeg": 73991,
	"./assets/News/news_7_3.png": 49858,
	"./assets/News/news_7_4.png": 11581,
	"./assets/News/news_7_5.png": 90452,
	"./assets/News/news_7_6.png": 95567,
	"./assets/News/news_7_7.png": 30374,
	"./assets/News/news_7_8.png": 41889,
	"./assets/News/news_7_9.png": 20760,
	"./assets/News/news_8_1.png": 73395,
	"./assets/News/news_8_10.png": 66779,
	"./assets/News/news_8_2.png": 98904,
	"./assets/News/news_8_3.png": 71617,
	"./assets/News/news_8_4.png": 4878,
	"./assets/News/news_8_5.png": 78519,
	"./assets/News/news_8_6.png": 89788,
	"./assets/News/news_8_7.png": 7301,
	"./assets/News/news_8_8.png": 6434,
	"./assets/News/news_8_9.png": 70091,
	"./assets/News/news_9_1.png": 60418,
	"./assets/font/MiSans VF.ttf": 90180,
	"./assets/font/Montserrat-VariableFont_wght.ttf": 24065,
	"./assets/font/font.css": 90924,
	"./assets/images/Group.png": 83525,
	"./assets/images/QRcode.png": 59296,
	"./assets/images/banner-text-vision.png": 33857,
	"./assets/images/banners-mobile.png": 52182,
	"./assets/images/banners.png": 90653,
	"./assets/images/base-1.png": 71659,
	"./assets/images/base-2.png": 1808,
	"./assets/images/base-3.png": 98713,
	"./assets/images/case-1.jpeg": 53353,
	"./assets/images/case-1.png": 38276,
	"./assets/images/case-2.jpeg": 22024,
	"./assets/images/case-2.png": 23551,
	"./assets/images/case-3.jpeg": 40543,
	"./assets/images/case-3.png": 69750,
	"./assets/images/case-4.png": 19721,
	"./assets/images/close.png": 61448,
	"./assets/images/code.png": 69293,
	"./assets/images/contact.png": 44572,
	"./assets/images/corporateVision.png": 77525,
	"./assets/images/corporates.png": 1666,
	"./assets/images/crisis-back.png": 74769,
	"./assets/images/down.png": 77110,
	"./assets/images/download.png": 50678,
	"./assets/images/grid1.png": 93765,
	"./assets/images/home-background.png": 85346,
	"./assets/images/home-title-opacity.png": 81966,
	"./assets/images/home-title.png": 4518,
	"./assets/images/infinite.png": 23734,
	"./assets/images/introduction-title.png": 86587,
	"./assets/images/left-line.png": 83654,
	"./assets/images/line-bottom.png": 37166,
	"./assets/images/lines.png": 98697,
	"./assets/images/logo.png": 74375,
	"./assets/images/material-banner.png": 66014,
	"./assets/images/material-title.png": 48768,
	"./assets/images/menu.png": 10855,
	"./assets/images/mint.png": 31810,
	"./assets/images/new-1.png": 42248,
	"./assets/images/number-1.png": 83359,
	"./assets/images/number-2.png": 98084,
	"./assets/images/part4.png": 42897,
	"./assets/images/product-1.jpeg": 84856,
	"./assets/images/product-2.jpg": 15568,
	"./assets/images/product-3.jpeg": 97970,
	"./assets/images/product-4.jpeg": 24051,
	"./assets/images/product-5.jpg": 8195,
	"./assets/images/product-6.jpg": 62132,
	"./assets/images/product_3.png": 56151,
	"./assets/images/project-3.png": 85127,
	"./assets/images/project.png": 25075,
	"./assets/images/scientific-2.png": 66572,
	"./assets/images/scientific.png": 17157,
	"./assets/images/story-1.png": 98773,
	"./assets/images/story-2.png": 78398,
	"./assets/images/story-3.png": 54183,
	"./assets/images/swiper3.png": 61571,
	"./assets/images/swiper4.png": 12172,
	"./assets/images/swiper5.png": 23797,
	"./assets/images/vision-title-opacity.png": 13719,
	"./assets/images/vision-title.png": 71739,
	"./assets/images/wechat.png": 88876,
	"./assets/images/wxCode.png": 97000,
	"./assets/images/wxCode2.jpg": 11756,
	"./components/AaModuleContent": 47033,
	"./components/AaModuleContent/": 47033,
	"./components/AaModuleContent/index": 47033,
	"./components/AaModuleContent/index.vue": 47033,
	"./components/AaModuleContentMobile": 85878,
	"./components/AaModuleContentMobile/": 85878,
	"./components/AaModuleContentMobile/index": 85878,
	"./components/AaModuleContentMobile/index.vue": 85878,
	"./components/BannerTitle": 55103,
	"./components/BannerTitle/": 55103,
	"./components/BannerTitle/index": 55103,
	"./components/BannerTitle/index.vue": 55103,
	"./components/BannerTitleAnimation": 11758,
	"./components/BannerTitleAnimation/": 11758,
	"./components/BannerTitleAnimation/index": 11758,
	"./components/BannerTitleAnimation/index.vue": 11758,
	"./components/BannerTitleAnimationMobile": 99736,
	"./components/BannerTitleAnimationMobile/": 99736,
	"./components/BannerTitleAnimationMobile/index": 99736,
	"./components/BannerTitleAnimationMobile/index.vue": 99736,
	"./components/BioIntelligent/BioIntelligentApplication": 96695,
	"./components/BioIntelligent/BioIntelligentApplication.vue": 96695,
	"./components/BioIntelligent/BioIntelligentPart1": 94762,
	"./components/BioIntelligent/BioIntelligentPart1.vue": 94762,
	"./components/BioIntelligent/BioIntelligentPart2": 20373,
	"./components/BioIntelligent/BioIntelligentPart2.vue": 20373,
	"./components/BioIntelligent/BioIntelligentPart3": 90172,
	"./components/BioIntelligent/BioIntelligentPart3.vue": 90172,
	"./components/BioIntelligent/BioIntelligentPart4": 29123,
	"./components/BioIntelligent/BioIntelligentPart4.vue": 29123,
	"./components/BioIntelligent/BioIntelligentPart5": 182,
	"./components/BioIntelligent/BioIntelligentPart5.vue": 182,
	"./components/BioIntelligent/BioIntelligentPart6": 81447,
	"./components/BioIntelligent/BioIntelligentPart6.vue": 81447,
	"./components/BioIntelligent/BioIntelligentPart7": 61862,
	"./components/BioIntelligent/BioIntelligentPart7.vue": 61862,
	"./components/Contact": 21868,
	"./components/Contact/": 21868,
	"./components/Contact/images/QRcode.png": 62370,
	"./components/Contact/images/divider.png": 2277,
	"./components/Contact/index": 21868,
	"./components/Contact/index.vue": 21868,
	"./components/ContactMobile": 8485,
	"./components/ContactMobile/": 8485,
	"./components/ContactMobile/images/QRcode.png": 55008,
	"./components/ContactMobile/images/divider.png": 19219,
	"./components/ContactMobile/index": 8485,
	"./components/ContactMobile/index.vue": 8485,
	"./components/Divider": 87185,
	"./components/Divider/": 87185,
	"./components/Divider/index": 87185,
	"./components/Divider/index.vue": 87185,
	"./components/Footer": 37426,
	"./components/Footer/": 37426,
	"./components/Footer/images/divider.png": 7664,
	"./components/Footer/index": 37426,
	"./components/Footer/index.vue": 37426,
	"./components/FooterMobile": 38333,
	"./components/FooterMobile/": 38333,
	"./components/FooterMobile/images/divider.png": 69814,
	"./components/FooterMobile/index": 38333,
	"./components/FooterMobile/index.vue": 38333,
	"./components/Header": 88900,
	"./components/Header/": 88900,
	"./components/Header/images/arrow_down.png": 39415,
	"./components/Header/images/arrow_up.png": 62204,
	"./components/Header/images/close.png": 50361,
	"./components/Header/images/download.png": 15301,
	"./components/Header/images/menu.png": 61380,
	"./components/Header/index": 88900,
	"./components/Header/index.vue": 88900,
	"./components/MiNTNews/MiNTNewsDetailCom": 27739,
	"./components/MiNTNews/MiNTNewsDetailCom.vue": 27739,
	"./components/MiNTNews/MiNTNewsDetailSection": 36660,
	"./components/MiNTNews/MiNTNewsDetailSection.vue": 36660,
	"./components/MiNTNews/MiNTNewsList": 89570,
	"./components/MiNTNews/MiNTNewsList.vue": 89570,
	"./components/MiNTNews/MiNTNewsListMobile": 89388,
	"./components/MiNTNews/MiNTNewsListMobile.vue": 89388,
	"./components/MiNTNews/MiNTNewsListPreview": 96642,
	"./components/MiNTNews/MiNTNewsListPreview.vue": 96642,
	"./components/MiNTNews/MiNTNewsOverview": 44211,
	"./components/MiNTNews/MiNTNewsOverview.vue": 44211,
	"./components/MiNTNews/MiNTNewsTest": 24216,
	"./components/MiNTNews/MiNTNewsTest.vue": 24216,
	"./components/MiNTNews/MiNTNewsTop": 38264,
	"./components/MiNTNews/MiNTNewsTop.vue": 38264,
	"./components/MiNTNews/NewsCardPreview": 10668,
	"./components/MiNTNews/NewsCardPreview.vue": 10668,
	"./components/MiNTProgress/MiNTProgress": 47941,
	"./components/MiNTProgress/MiNTProgress.vue": 47941,
	"./components/MobileHeader": 66561,
	"./components/MobileHeader/": 66561,
	"./components/MobileHeader/images/arrow_down.png": 97757,
	"./components/MobileHeader/images/arrow_up.png": 85126,
	"./components/MobileHeader/images/close.png": 25159,
	"./components/MobileHeader/images/download.png": 36347,
	"./components/MobileHeader/images/menu.png": 16750,
	"./components/MobileHeader/index": 66561,
	"./components/MobileHeader/index.vue": 66561,
	"./components/MouseScroll": 6064,
	"./components/MouseScroll/": 6064,
	"./components/MouseScroll/index": 6064,
	"./components/MouseScroll/index.vue": 6064,
	"./components/MouseScrollM": 71194,
	"./components/MouseScrollM/": 71194,
	"./components/MouseScrollM/index": 71194,
	"./components/MouseScrollM/index.vue": 71194,
	"./components/MouseScrollMobile": 94916,
	"./components/MouseScrollMobile/": 94916,
	"./components/MouseScrollMobile/index": 94916,
	"./components/MouseScrollMobile/index.vue": 94916,
	"./components/Propagate": 48375,
	"./components/Propagate/": 48375,
	"./components/Propagate/index": 48375,
	"./components/Propagate/index.vue": 48375,
	"./components/Swiper": 81701,
	"./components/Swiper/": 81701,
	"./components/Swiper/index": 81701,
	"./components/Swiper/index.vue": 81701,
	"./event/event": 41052,
	"./event/event.js": 41052,
	"./i18n/common/en-US": 79542,
	"./i18n/common/en-US.json": 79542,
	"./i18n/common/zh-CN": 2876,
	"./i18n/common/zh-CN.json": 2876,
	"./i18n/en-US": 7964,
	"./i18n/en-US.json": 7964,
	"./i18n/modules/navigation/en-US": 68643,
	"./i18n/modules/navigation/en-US.json": 68643,
	"./i18n/modules/navigation/zh-CN": 32693,
	"./i18n/modules/navigation/zh-CN.json": 32693,
	"./i18n/modules/news/en-US": 38298,
	"./i18n/modules/news/en-US.json": 38298,
	"./i18n/modules/news/zh-CN": 73504,
	"./i18n/modules/news/zh-CN.json": 73504,
	"./i18n/modules/pages/en-US": 43601,
	"./i18n/modules/pages/en-US.json": 43601,
	"./i18n/modules/pages/zh-CN": 67063,
	"./i18n/modules/pages/zh-CN.json": 67063,
	"./i18n/modules/products/en-US": 84141,
	"./i18n/modules/products/en-US.json": 84141,
	"./i18n/modules/products/zh-CN": 1443,
	"./i18n/modules/products/zh-CN.json": 1443,
	"./i18n/zh-CN": 8318,
	"./i18n/zh-CN.json": 8318,
	"./main": 51406,
	"./main.js": 51406,
	"./pages/AminoAcid": 73668,
	"./pages/AminoAcid/": 73668,
	"./pages/AminoAcid/index": 73668,
	"./pages/AminoAcid/index.vue": 73668,
	"./pages/AminoAcidMobile": 89974,
	"./pages/AminoAcidMobile/": 89974,
	"./pages/AminoAcidMobile/index": 89974,
	"./pages/AminoAcidMobile/index.vue": 89974,
	"./pages/BioIntelligent": 47340,
	"./pages/BioIntelligent/": 47340,
	"./pages/BioIntelligent/index": 47340,
	"./pages/BioIntelligent/index.vue": 47340,
	"./pages/BioIntelligentMobile": 33329,
	"./pages/BioIntelligentMobile/": 33329,
	"./pages/BioIntelligentMobile/index": 33329,
	"./pages/BioIntelligentMobile/index.vue": 33329,
	"./pages/CorporateVision": 88585,
	"./pages/CorporateVision/": 88585,
	"./pages/CorporateVision/index": 88585,
	"./pages/CorporateVision/index.vue": 88585,
	"./pages/CorporateVisionMobile": 35563,
	"./pages/CorporateVisionMobile/": 35563,
	"./pages/CorporateVisionMobile/index": 35563,
	"./pages/CorporateVisionMobile/index.vue": 35563,
	"./pages/Home": 42255,
	"./pages/Home/": 42255,
	"./pages/Home/index": 42255,
	"./pages/Home/index.vue": 42255,
	"./pages/HomeMobile": 66999,
	"./pages/HomeMobile/": 66999,
	"./pages/HomeMobile/index": 66999,
	"./pages/HomeMobile/index.vue": 66999,
	"./pages/KnotWeed": 20463,
	"./pages/KnotWeed/": 20463,
	"./pages/KnotWeed/index": 20463,
	"./pages/KnotWeed/index.vue": 20463,
	"./pages/KnotWeedMobile": 9362,
	"./pages/KnotWeedMobile/": 9362,
	"./pages/KnotWeedMobile/index": 9362,
	"./pages/KnotWeedMobile/index.vue": 9362,
	"./pages/MiNTNews/MiNTNews": 24081,
	"./pages/MiNTNews/MiNTNews.vue": 24081,
	"./pages/MiNTNews/MiNTNewsDetail": 76003,
	"./pages/MiNTNews/MiNTNewsDetail.vue": 76003,
	"./pages/MiNTNewsMobile/MiNTNewsDetailMobile": 44816,
	"./pages/MiNTNewsMobile/MiNTNewsDetailMobile.vue": 44816,
	"./pages/MiNTNewsMobile/MiNTNewsMobile": 30162,
	"./pages/MiNTNewsMobile/MiNTNewsMobile.vue": 30162,
	"./pages/NewMaterial": 98089,
	"./pages/NewMaterial/": 98089,
	"./pages/NewMaterial/index": 98089,
	"./pages/NewMaterial/index.vue": 98089,
	"./pages/NewMaterialMobile": 73593,
	"./pages/NewMaterialMobile/": 73593,
	"./pages/NewMaterialMobile/index": 73593,
	"./pages/NewMaterialMobile/index.vue": 73593,
	"./pages/Vision": 82405,
	"./pages/Vision/": 82405,
	"./pages/Vision/VisionModule5": 87140,
	"./pages/Vision/VisionModule5.vue": 87140,
	"./pages/Vision/images/banner1.png": 35975,
	"./pages/Vision/images/banner2_1.jpg": 38680,
	"./pages/Vision/images/banner2_2.jpg": 35015,
	"./pages/Vision/images/banner2_3.jpg": 67274,
	"./pages/Vision/images/banner2_4.jpg": 3993,
	"./pages/Vision/images/banner3_list_info.png": 23599,
	"./pages/Vision/images/banner_title.png": 19155,
	"./pages/Vision/images/book_icon.png": 78245,
	"./pages/Vision/images/down.png": 44958,
	"./pages/Vision/images/grid.png": 47638,
	"./pages/Vision/images/module5_img1.jpeg": 53637,
	"./pages/Vision/images/module5_img2.png": 10515,
	"./pages/Vision/images/module5_img3.jpeg": 72459,
	"./pages/Vision/images/module5_img4.png": 22181,
	"./pages/Vision/images/process.png": 16219,
	"./pages/Vision/images/semicolon_icon.png": 20927,
	"./pages/Vision/images/trend.png": 72533,
	"./pages/Vision/index": 82405,
	"./pages/Vision/index.vue": 82405,
	"./pages/VisionMobile": 87202,
	"./pages/VisionMobile/": 87202,
	"./pages/VisionMobile/CrisisCard": 7954,
	"./pages/VisionMobile/CrisisCard/": 7954,
	"./pages/VisionMobile/CrisisCard/index": 7954,
	"./pages/VisionMobile/CrisisCard/index.vue": 7954,
	"./pages/VisionMobile/VisionModule5": 66797,
	"./pages/VisionMobile/VisionModule5.vue": 66797,
	"./pages/VisionMobile/images/banner1.png": 34445,
	"./pages/VisionMobile/images/banner2_1.jpg": 29030,
	"./pages/VisionMobile/images/banner2_2.jpg": 86801,
	"./pages/VisionMobile/images/banner2_3.jpg": 73076,
	"./pages/VisionMobile/images/banner2_4.jpg": 93887,
	"./pages/VisionMobile/images/banner3_list_info.png": 77665,
	"./pages/VisionMobile/images/banner_title.png": 15241,
	"./pages/VisionMobile/images/book_icon.png": 19067,
	"./pages/VisionMobile/images/down.png": 73820,
	"./pages/VisionMobile/images/grid.png": 65560,
	"./pages/VisionMobile/images/module5_img1.jpeg": 8007,
	"./pages/VisionMobile/images/module5_img2.png": 46021,
	"./pages/VisionMobile/images/module5_img3.jpeg": 99569,
	"./pages/VisionMobile/images/module5_img4.png": 16563,
	"./pages/VisionMobile/images/process.png": 21493,
	"./pages/VisionMobile/images/semicolon_icon.png": 42765,
	"./pages/VisionMobile/images/trend.png": 29603,
	"./pages/VisionMobile/index": 87202,
	"./pages/VisionMobile/index.vue": 87202,
	"./postcss.config": 69204,
	"./postcss.config.js": 69204,
	"./router": 39325,
	"./router/": 39325,
	"./router/index": 39325,
	"./router/index.js": 39325,
	"./style/common.less": 21222,
	"./style/variable.less": 94403,
	"./utils": 61981,
	"./utils/": 61981,
	"./utils/directives": 90264,
	"./utils/directives/": 90264,
	"./utils/directives/index": 90264,
	"./utils/directives/index.js": 90264,
	"./utils/directives/intersect": 38457,
	"./utils/directives/intersect.js": 38457,
	"./utils/index": 61981,
	"./utils/index.js": 61981,
	"./utils/isPc": 48260,
	"./utils/isPc.js": 48260,
	"./utils/language": 94875,
	"./utils/language.js": 94875
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;